import { materialType, lensType, clMaterial, waterContent, lensTypeTarget, caseIncluded, minimumCycleTime, preservativeFree, maxTimeFrameInLensCase, expirationAfterOpening } from "../../../../../library/modules/PrimaryProductInfo/ProductDetailSpecification/library/library.js";
const defaultCLFeatureSpecifications = [
  materialType,
  lensType,
  clMaterial,
  waterContent
];
const defaultSolutionsFeatureSpecifications = [
  lensTypeTarget,
  caseIncluded,
  minimumCycleTime,
  preservativeFree,
  maxTimeFrameInLensCase,
  expirationAfterOpening
];
export {
  defaultCLFeatureSpecifications,
  defaultSolutionsFeatureSpecifications
};
//# sourceMappingURL=product-feature-defaults.js.map
